import { render } from "./App.vue?vue&type=template&id=61f264cb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=61f264cb&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__